/// \file depotRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2024 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Route } from "react-router-dom";
import depotManagementRoutes from './depotManagementRoutes';

const routes = (
  <Route
    path="depots"
    handle={{
      text: 'Depot'
    }}
    >
    {depotManagementRoutes}
  </Route>
);

export default routes;